import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import styled from "styled-components";
import { _ } from "../utils/i18n";

import Breadcrumbs from "../components/breadcrumbs";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

const Span = styled.span`
  align-items: flex-start;
  display: flex;
  &:not(:last-child) {
    &:hover {
      text-decoration: underline;
    }
  }
  &:last-child {
    margin-right: 30px;
  }
  &.breadcrumbs {
    text-decoration: none;
  }
`;
const BreadLink = styled((props) => <Link {...props} />)`
  text-decoration: none;
  & span {
    white-space: nowrap;
  }
`;
const SpanActive = styled.span`
  color: #8b8b8b;
  text-overflow: clip;
  white-space: nowrap;
`;

const Breadcrumb = ({ post, className }) => {
  const pagePaths = post.uri?.split("/");

  const { breadCrumbs } = useStaticQuery(
    graphql`
      query {
        breadCrumbs: allWpContentNode(
          filter: { nodeType: { in: ["Case", "Page", "Post", "Service"] } }
        ) {
          nodes {
            databaseId
            uri
            slug
            ... on WpCase {
              title
            }
            ... on WpPage {
              title
              parentDatabaseId
            }
            ... on WpPost {
              title
              parentDatabaseId
            }
            ... on WpService {
              title
            }
          }
        }
      }
    `
  );

  return (
    <Breadcrumbs className={className}>
      <Span
        itemProp="itemListElement"
        itemScope
        itemType="http://schema.org/ListItem"
        className={className}
      >
        <BreadLink itemProp="item" to="/">
          <span className={className} itemProp="name">
            {_("Hjem")}
          </span>
        </BreadLink>
        <ArrowRightIcon />
        <meta itemProp="position" content="1" />
      </Span>

      {pagePaths?.map((path, pathIndex) =>
        breadCrumbs.nodes
          .filter((node) => path === node.slug && node.uri !== post.uri)
          .map((pathData, i) => (
            <Span
              key={i}
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
              className={className}
            >
              <BreadLink itemProp="item" to={pathData.uri}>
                <span itemProp="name" className={className}>
                  {pathData.title.replace("&#038;", "&").replace("&amp;", "&")}
                </span>
              </BreadLink>
              <meta itemProp="position" content={pathIndex + 1} />
              <ArrowRightIcon />
            </Span>
          ))
      )}

      <Span
        itemProp="itemListElement"
        itemScope
        itemType="http://schema.org/ListItem"
        className="breadcrumbs"
      >
        <SpanActive itemProp="name" className={className}>
          {post.title.replace("&#038;", "&").replace("&amp;", "&")}
        </SpanActive>
        <meta
          itemProp="position"
          content={pagePaths?.filter((x) => x).length + 1}
        />
      </Span>
    </Breadcrumbs>
  );
};

Breadcrumb.propTypes = {
  post: PropTypes.object,
  className: PropTypes.string,
};

Breadcrumb.defaultProps = {
  post: undefined,
};

export default Breadcrumb;
